import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// primereact
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { InputMask } from "primereact/inputmask";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import ExportTable from "../../../components/button/ExportButton";
import { useAppContext } from "../../../context/AppContext";
import usePermission from "../../../hooks/usePermission";

export default function Simulations() {
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  usePermission("25");
  // eslint-disable-next-line no-unused-vars
  const [visible, setVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tableData, setTableData] = useState([
    { simulation: "1", client: "Ana", date: "14", status: "10" },
  ]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const columns = [
    { field: "simulation", header: "Simulação" },
    { field: "client", header: "Cliente" },
    { field: "date", header: "Data" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const items = [
    {
      template: () => (
        <Link to={"/reports/simulations"} className="p-breadcrumb-link">
          Simulações
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const cities = [
    { name: "New York", code: "NY" },
    { name: "Rome", code: "RM" },
    { name: "London", code: "LDN" },
    { name: "Istanbul", code: "IST" },
    { name: "Paris", code: "PRS" },
  ];



  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Simulações de Venda">
        <div className="row d-flex mt-4">
          <div className="col-md-4 mb-3 form-group">
            <span className="p-float-label">
              <Dropdown
                inputId="dd-city"
                // value={selectedCity}
                // onChange={(e) => setSelectedCity(e.value)}
                options={cities}
                optionLabel="Nome"
                className="w-100"
              />
              <label htmlFor="dd-city">Loteamento Jardim</label>
            </span>
          </div>
          <div className="col-md-4 mb-3 form-group">
            <span className="p-float-label">
              <InputMask
                id="ssn_input"
                // value={value}
                // onChange={(e) => setValue(e.target.value)}
                mask="999.999.999-99"
                className="w-100"
              />
              <label htmlFor="ssn_input">Cliente</label>
            </span>
          </div>
          <div className="col-md-3 mb-3 form-group">
            <span className="p-float-label">
              <InputMask
                id="ssn_input"
                // value={value}
                // onChange={(e) => setValue(e.target.value)}
                mask="999.999.999-99"
                className="w-100"
              />
              <label htmlFor="ssn_input">Número da Simulação</label>
            </span>
          </div>
          <div className="col-md-1 h-100 form-group">
            <div className="text-center">
              <Button label="Pesquisar" />
            </div>
          </div>
        </div>
      </Panel>

      {!visible && (
        <Panel mainCss="mt-4">
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <ExportTable
                tableData={tableData}
                exportColumns={exportColumns}
                tabelaKey="Relatório de Simulações"
                globalFilterValue={globalFilterValue}
                onGlobalFilterChange={onGlobalFilterChange}
              />
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={tableData}
                totalRecords={tableData.length}
                globalFilter={globalFilterValue}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  // filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                ))}
                <Column
                  header="Ver Simulação
                  
                  "
                  body={(rowData) => (
                    <div className="text-center">
                      <button
                        className="btn btn-success btn-btn-sm"
                      // onClick={() => setSelectedRow(rowData)}
                      >
                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                      </button>
                    </div>
                  )}
                />
              </DataTable>
            </div>
          </>
        </Panel>
      )}
    </div>
  );
}
